"use strict";

exports.__esModule = true;
exports["default"] = uniqueId;

var _guid = _interopRequireDefault(require("rc-util/lib/guid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function uniqueId() {
  return "react-grv-" + (0, _guid["default"])();
}